import React, { useCallback, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField';
import { PrimaryLayout } from '../Layout';

function PrimaryTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const isSaved = props?.formFields?.RowId && props.formFields.RowId !== "00000000-0000-0000-0000-000000000000";

    const loadLookupClient = useCallback((name, dataSource, valueExpr = 'id', displayExpr = 'text') => {
        if (!props.formRefs?.current?.[name]) return;
        const ref = props.formRefs.current[name];
        if (!ref?.instance) return;

        ref.instance().option('dataSource', dataSource);
        ref.instance().option('valueExpr', valueExpr);
        ref.instance().option('displayExpr', displayExpr);
    }, [props.formRefs]);

    const finalLayout = useMemo(() => {
        return PrimaryLayout.map(group => ({
            ...group,
            fields: group.fields.map(field => {
                if (field.name === 'RProfile' && isSaved) {
                    return { ...field, readOnly: true };
                }
                return field;
            })
        }));
    }, [isSaved]);

    const handlePrimaryFormLoad = useCallback(() => {
        const statusOptions = [
            { id: 'A', text: 'Active' },
            { id: 'I', text: 'Inactive' }
        ];

        const yesNoOptions = [
            { id: 'Y', text: 'Yes' },
            { id: 'N', text: 'No' }
        ];

        setTimeout(() => {
            loadLookupClient("Status", statusOptions);
            loadLookupClient("ApplyOnTax1", yesNoOptions);
        }, 100);
    }, [loadLookupClient]);

    useEffect(() => {
        const statusOptions = [
            { id: 'A', text: 'Active' },
            { id: 'I', text: 'Inactive' }
        ];

        const yesNoOptions = [
            { id: 'Y', text: 'Yes' },
            { id: 'N', text: 'No' }
        ];

        loadLookupClient("Status", statusOptions);
        loadLookupClient("ApplyOnTax1", yesNoOptions);
    }, [props.formFields?.RowId]);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='50B81127-9732-4CCF-8E84-CDEAB4090012'
                layoutName='OMSalesTaxCodePrimaryForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handlePrimaryFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(PrimaryTab);
